import React from 'react'

import Headerbar from './Headerbar';

import Tag from '../components/Tag';
import Button from '../components/Button';
import Heading from '../components/Heading';

export default function About(props) {
  return (
    <div className='relative w-full flex flex-col justify-start items-center h-full mt-auto text-blue'
        onMouseEnter={() => props.setHover({})}>
      <div className='flex my-auto flex-col justify-center items-center w-full h-fit p-[1.5rem] pt-[15vh] relative z-0 max-w-[2000px]'>
          <div className='relative z-40 w-[50%] h-fit flex flex-col lg:flex-row justify-center items-center max-w-[600px] my-[5vw]'>
              <div className='items-center flex flex-col w-[75%] min-w-[300px] lg:max-w-[800px] h-full driftinfast mb-[2rem] lg:mb-0'>
                  <img className='w-[50%] h-auto max-w-[300px] min-w-[200px]' src={require('../images/face.png')} alt='my face'/>
                  <img className='mb-[2rem] w-[95%] h-auto max-w-[400px]' src={require('../images/HELLO.png')} alt='hello'/>
              </div>
          </div>
          <p className='text-center w-full max-w-[1000px] lg:text-base hyphens-none'>
            I'm Tom, a <mark>Mechanical Engineering</mark> student at <mark>Northwestern University</mark> specializing in <mark>Robotics</mark>.
            <br/><br/>
            I love robotics for its variety: <mark>mechanical design, embedded systems, rapid prototyping, and testing</mark> all come together to bring a machine to life on my desk. My research and personal projects have helped me build full-stack skills across robotics, and I'm excited to learn from senior engineers and researchers wherever my career takes me.
            <br/><br/>
            Around campus, you'll usually find me hunched over a stubborn line of code, endlessly orbiting my CAD assemblies, or with my face smushed into the glass of a CNC mill. But lately, I've also been spending much of my time at the <a className='underline font-[600]' href='https://hand-erc.org/'>Northwestern HAND Lab</a>, working with <mark>dexterous robotic systems</mark> and sharpening my communication skills as a researcher. 
            You can find my work in the projects section below.
            <br/><br/>
            Outside the lab, I love to draw, whether it's little doodles in the margins of my lecture notes or finished pieces for my <a className='underline font-[600]' href='https://www.instagram.com/artbyhunch'>art account</a>. Music always keeps me drawing, and the song I'm listening to right now might be inspiring my next work. What started as a hobby sketching funny little characters has led to digital artwork that I'm very proud of, including commissions for some awesome clients.
            <br/><br/>
            Stay awhile, and enjoy!
          </p>
          <div>
            <img className='mt-[2rem] w-[200px]' src={require('../images/signature.png')} alt='signature'/>
          </div>
        </div>
        <div className='flex flex-row z-0'>
          <a className='keplersemi text-blue w-fit my-[2rem]' href='/projects'>
            <Button {... props}>
              <div className='flex flex-row space-x-[0.5rem] justify-start items-center'>
                <img className='h-[1rem] aspect-square' src={require('../images/link.png')} alt='arrow'/>
                <div className='pt-[3px]'>{'SEE PROJECTS'}</div>
              </div>
            </Button>
          </a>  
          <a className='keplersemi text-blue w-fit my-[2rem]' href='/digitalart'>
            <Button {... props}>
              <div className='flex flex-row space-x-[0.5rem] justify-start items-center'>
                <img className='h-[1rem] aspect-square' src={require('../images/link.png')} alt='arrow'/>
                <div className='pt-[3px]'>{'EXPLORE DIGITAL ART'}</div>
              </div>
            </Button>
          </a> 
        </div>
        <Headerbar {... props}/>
    </div>
  )
}